export const ALLOWLIST_PAGE_BASE_PATH = "/settings/api-allowlist";
